// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
import uuid from 'uuid/v4';

import { DecorationSet } from '@atlaskit/editor-prosemirror/view';

import { ACTIONS } from './states';
import type { InlineSuggestionState, InlineSuggestionAction } from './states';

export const reducer = (
	pluginState: InlineSuggestionState,
	action: InlineSuggestionAction,
): InlineSuggestionState => {
	switch (action.type) {
		case ACTIONS.CLEAR_INLINE_SUGGESTION:
			return {
				...pluginState,
				inlineSuggestion: null,
				decorationSet: DecorationSet.empty,
				inlineSuggestionSessionId: null,
			};
		case ACTIONS.UPDATE_INLINE_SUGGESTION: {
			let sessionID = null;
			if (action.payload.inlineSuggestion) {
				// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
				sessionID = pluginState.inlineSuggestion ? pluginState.inlineSuggestionSessionId : uuid();
			}
			return {
				...pluginState,
				inlineSuggestion: action.payload.inlineSuggestion,
				decorationSet: action.payload.decorationSet,
				inlineSuggestionSessionId: sessionID,
			};
		}
		case ACTIONS.UPDATE_LOCALE: {
			return {
				...pluginState,
				locale: action.payload.locale,
			};
		}
		default:
			return pluginState;
	}
};
